import {RouteUrls} from '../constants/RouteUrls';
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";

export class Util {

  private static consumedIds = [];

  static formatUrlParams(obj: any[] | null): string {
    let urlParameters = '?';
    for (const objKey of obj) {
      urlParameters += objKey + '=' + obj[objKey];
    }
    return urlParameters;
  }

  public static padNumber(n) {
    return String(n).padStart(7, '0');
  }

  public static unPadNumber(n) {
    return parseInt(n, 10);
  }

  public static unwrapSafely(obj: any, props: string, defaultValue: any = null) {
    const properties = props.split('.');
    let value = obj;
    if (!value) {
      return defaultValue;
    }
    if (!props || properties.length === 0) {
      return obj;
    }
    for (const property of properties) {
      value = value[property];
      if (value === null || value === undefined) {
        return defaultValue;
      }
    }
    return value;
  }

  public static generateRandomId(): number {
    const random = Math.floor(Math.random() * Math.floor(1000000));
    return this.consumedIds.includes(random) ? this.generateRandomId() : random;
  }

  public static getRedirectionUrl(userRoles: any[]): string {
    return `/${RouteUrls.DASHBOARD.MODULE_BASE}`;
  }

  /**
   * Check if objects values are the same. Returns true if values are the same.
   * Empty string and null is considered equal.
   * @param objectValues original object values
   * @param objectValuesToCheck object values to check
   */
  public static sameArrayObjectsValues(objectValues: any[], objectValuesToCheck: any[]): boolean {
    if (objectValues == null && objectValuesToCheck == null) {
      return true;
    } else if (objectValues == null || objectValuesToCheck == null) {
      return false;
    }
    if (objectValues.length !== objectValuesToCheck.length) {
      return false;
    }

    for (let i = 0; i < objectValues.length; i++) {
      if (!this.sameObjectValues(objectValues[i], objectValuesToCheck[i])) {
        return false;
      }
    }

    return true;
  }

  /**
   * Check if object values including sub object values are the same. Returns true if values are the same.
   * Empty string and null is considered equal.
   * @param objectValues original object values
   * @param objectValuesToCheck object values to check
   */
  public static sameObjectValues(objectValues: any, objectValuesToCheck: any): boolean {
    if (objectValues == null && objectValuesToCheck == null) {
      return true;
    } else if (objectValues == null || objectValuesToCheck == null) {
      return false;
    }

    const objectValuesKeys = Object.keys(objectValues);
    const objectValuesToCheckKeys = Object.keys(objectValuesToCheck);

    if (objectValuesKeys.length !== objectValuesToCheckKeys.length) {
      return false;
    }

    for (const key of objectValuesKeys) {
      if (!objectValuesToCheckKeys.includes(key)) {
        return false;
      }

      if (typeof objectValues[key] === 'object' && typeof objectValuesToCheck[key] === 'object') {
        return this.sameObjectValues(objectValues[key], objectValuesToCheck[key]);
      } else if (Array.isArray(objectValues[key]) && Array.isArray(objectValuesToCheck[key])) {
        return this.sameArrayObjectsValues(objectValues[key], objectValuesToCheck[key]);
      } else {
        if ((objectValues[key] === null && objectValuesToCheck[key] === '')
          || (objectValues[key] === '' && objectValuesToCheck[key] === null)) {
          return true;
        }
        if (objectValues[key] !== objectValuesToCheck[key]) {
          return false;
        }
      }
    }

    return true;
  }

  public static addCurrentTimeToDate(date: Date): Date {
    if (date) {
      const currentTime = new Date();
      const newDate = new Date(date);
      newDate.setHours(currentTime.getHours());
      newDate.setMinutes(currentTime.getMinutes());
      newDate.setSeconds(currentTime.getSeconds());

      return newDate;
    }
    return null;
  }
}
